import axios, { AxiosResponse } from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

type CheckToolVersionDraftCompatibilityResponse = {
  compatibility: "compatible" | "incompatible" | "first_version";
};

export const checkToolVersionDraftCompatibility = async (
  toolVersionId: number,
): Promise<CheckToolVersionDraftCompatibilityResponse> => {
  const headers = await getRequestHeaders();

  const res = await axios.get<
    undefined,
    AxiosResponse<CheckToolVersionDraftCompatibilityResponse>
  >(getEnvVar("URL_TRS_TOOL_VERSION_DRAFT_COMPATIBLE")(toolVersionId), {
    headers,
  });

  return res.data;
};
